import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { IMAGES, NAV_LINKS, CONTACT } from "../../lib/constants";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-bege/95 backdrop-blur-md shadow-md border-b border-[#C9A84C]/30"
          : "bg-bege/80 backdrop-blur-sm"
      }`}
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-3 flex items-center justify-between gap-4">
        <a href="#inicio" className="flex items-center gap-3 shrink-0" data-testid="header-logo">
          <img
            src={IMAGES.logo}
            alt="O Padrinho — Restaurante e Lanchonete"
            className="h-[60px] w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-dark hover:text-bordo transition-colors relative group"
              data-testid={`nav-link-${l.href.replace("#", "")}`}
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-gold group-hover:w-full transition-all duration-300" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={CONTACT.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-whatsapp hidden md:inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold"
            data-testid="header-whatsapp-cta"
          >
            <MessageCircle size={16} fill="currentColor" strokeWidth={0} />
            WhatsApp
          </a>
          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-bordo"
            aria-label="Menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="lg:hidden bg-bege border-t border-[#C9A84C]/30 shadow-lg"
        >
          <div className="px-6 py-5 flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2 text-dark hover:text-bordo transition-colors font-medium"
                data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href={CONTACT.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 font-semibold mt-2"
              data-testid="mobile-whatsapp-cta"
            >
              <MessageCircle size={16} fill="currentColor" strokeWidth={0} /> WhatsApp
            </a>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
};

export default Header;
